/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {LiceSource} from '../bioplanModels';
// @ts-ignore
import type {LiceSourceOrder} from '../bioplanModels';
// @ts-ignore
import type {LiceStatus} from '../bioplanModels';
/**
 * EnvironmentLiceApi - axios parameter creator
 * @export
 */
export const EnvironmentLiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get lice status for a cage.
     * @param {string} date
     * @param {string} siteId
     * @param {string} [cageId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceGet: async (
      date: string,
      siteId: string,
      cageId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'date' is not null or undefined
      assertParamExists('liceGet', 'date', date);
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('liceGet', 'siteId', siteId);
      const localVarPath = `/lice/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString().substring(0, 10) : date;
      }

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get data sources that are actively in use.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceSourcesActiveGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/lice/sources/active`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all lice data sources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceSourcesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/lice/sources`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Reorder priority of lice data sources.
     * @param {LiceSourceOrder} liceSourceOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceSourcesReorderPut: async (
      liceSourceOrder: LiceSourceOrder,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'liceSourceOrder' is not null or undefined
      assertParamExists('liceSourcesReorderPut', 'liceSourceOrder', liceSourceOrder);
      const localVarPath = `/lice/sources/reorder`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(liceSourceOrder, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Reset lice sources to the default order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceSourcesResetPut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/lice/sources/reset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EnvironmentLiceApi - functional programming interface
 * @export
 */
export const EnvironmentLiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EnvironmentLiceApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get lice status for a cage.
     * @param {string} date
     * @param {string} siteId
     * @param {string} [cageId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liceGet(
      date: string,
      siteId: string,
      cageId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiceStatus>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liceGet(date, siteId, cageId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EnvironmentLiceApi.liceGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get data sources that are actively in use.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liceSourcesActiveGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiceSource>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liceSourcesActiveGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EnvironmentLiceApi.liceSourcesActiveGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List all lice data sources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liceSourcesGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiceSource>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liceSourcesGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EnvironmentLiceApi.liceSourcesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Reorder priority of lice data sources.
     * @param {LiceSourceOrder} liceSourceOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liceSourcesReorderPut(
      liceSourceOrder: LiceSourceOrder,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiceSource>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liceSourcesReorderPut(liceSourceOrder, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EnvironmentLiceApi.liceSourcesReorderPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Reset lice sources to the default order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async liceSourcesResetPut(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LiceSource>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.liceSourcesResetPut(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EnvironmentLiceApi.liceSourcesResetPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * EnvironmentLiceApi - factory interface
 * @export
 */
export const EnvironmentLiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EnvironmentLiceApiFp(configuration);
  return {
    /**
     *
     * @summary Get lice status for a cage.
     * @param {EnvironmentLiceApiLiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceGet(
      requestParameters: EnvironmentLiceApiLiceGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LiceStatus> {
      return localVarFp
        .liceGet(requestParameters.date, requestParameters.siteId, requestParameters.cageId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get data sources that are actively in use.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceSourcesActiveGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<LiceSource>> {
      return localVarFp.liceSourcesActiveGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List all lice data sources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceSourcesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<LiceSource>> {
      return localVarFp.liceSourcesGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Reorder priority of lice data sources.
     * @param {EnvironmentLiceApiLiceSourcesReorderPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceSourcesReorderPut(
      requestParameters: EnvironmentLiceApiLiceSourcesReorderPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<LiceSource>> {
      return localVarFp
        .liceSourcesReorderPut(requestParameters.liceSourceOrder, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Reset lice sources to the default order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    liceSourcesResetPut(options?: RawAxiosRequestConfig): AxiosPromise<Array<LiceSource>> {
      return localVarFp.liceSourcesResetPut(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for liceGet operation in EnvironmentLiceApi.
 * @export
 * @interface EnvironmentLiceApiLiceGetRequest
 */
export interface EnvironmentLiceApiLiceGetRequest {
  /**
   *
   * @type {string}
   * @memberof EnvironmentLiceApiLiceGet
   */
  readonly date: string;

  /**
   *
   * @type {string}
   * @memberof EnvironmentLiceApiLiceGet
   */
  readonly siteId: string;

  /**
   *
   * @type {string}
   * @memberof EnvironmentLiceApiLiceGet
   */
  readonly cageId?: string;
}

/**
 * Request parameters for liceSourcesReorderPut operation in EnvironmentLiceApi.
 * @export
 * @interface EnvironmentLiceApiLiceSourcesReorderPutRequest
 */
export interface EnvironmentLiceApiLiceSourcesReorderPutRequest {
  /**
   *
   * @type {LiceSourceOrder}
   * @memberof EnvironmentLiceApiLiceSourcesReorderPut
   */
  readonly liceSourceOrder: LiceSourceOrder;
}

/**
 * EnvironmentLiceApi - object-oriented interface
 * @export
 * @class EnvironmentLiceApi
 * @extends {BaseAPI}
 */
export class EnvironmentLiceApi extends BaseAPI {
  /**
   *
   * @summary Get lice status for a cage.
   * @param {EnvironmentLiceApiLiceGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EnvironmentLiceApi
   */
  public liceGet(requestParameters: EnvironmentLiceApiLiceGetRequest, options?: RawAxiosRequestConfig) {
    return EnvironmentLiceApiFp(this.configuration)
      .liceGet(requestParameters.date, requestParameters.siteId, requestParameters.cageId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get data sources that are actively in use.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EnvironmentLiceApi
   */
  public liceSourcesActiveGet(options?: RawAxiosRequestConfig) {
    return EnvironmentLiceApiFp(this.configuration)
      .liceSourcesActiveGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List all lice data sources.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EnvironmentLiceApi
   */
  public liceSourcesGet(options?: RawAxiosRequestConfig) {
    return EnvironmentLiceApiFp(this.configuration)
      .liceSourcesGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Reorder priority of lice data sources.
   * @param {EnvironmentLiceApiLiceSourcesReorderPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EnvironmentLiceApi
   */
  public liceSourcesReorderPut(
    requestParameters: EnvironmentLiceApiLiceSourcesReorderPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EnvironmentLiceApiFp(this.configuration)
      .liceSourcesReorderPut(requestParameters.liceSourceOrder, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Reset lice sources to the default order
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EnvironmentLiceApi
   */
  public liceSourcesResetPut(options?: RawAxiosRequestConfig) {
    return EnvironmentLiceApiFp(this.configuration)
      .liceSourcesResetPut(options)
      .then((request) => request(this.axios, this.basePath));
  }
}
